<script>
  import Card from '../components/msg/card';
  import List from '../components/msg/list';
  import Text1 from '../components/msg/text';
  import Message from '../components/msg/message';

  export default {
    components: { Card, List, Text1, Message },
    mounted() {},
    methods: {},
  };
</script>

<template>
  <div id="app1" style="margin-top: 20px">
    <!-- <div class="sidebar">
      <card></card>
      <list></list>
    </div>
    <div class="main">
      <message></message>
      <text1></text1>
    </div>
    <div style="position: absolute; margin: 10px">
      <el-alert
        title="软件说明：小信鸽是一款多平台消息一站式处理工具，目前可同时支持代练通、咕噜代练、易代练等平台的消息收发。
         试用期：1个月。"
        type="success"
        show-icon></el-alert>
    </div>-->
  </div>
</template>

<style lang="less" scoped>
  #app1 {
    margin: 0 auto;
    height: 600px;

    overflow: hidden;
    border-radius: 3px;

    .sidebar,
    .main {
      height: 100%;
    }

    .sidebar {
      float: left;
      width: 200px;
      color: #f4f4f4;
      background-color: #2e3238;
    }

    .main {
      position: relative;
      overflow: hidden;
      background-color: #eee;
    }

    .text {
      position: absolute;
      width: 100%;
      bottom: 0;
      left: 0;
    }

    .message {
      height: ~'calc(100% - 160px)';
    }
  }
</style>
